import { Directive, Input } from '@angular/core';
import { InstrumentHeaderModel, InstrumentType, InstrumentUnderlyingModel } from '@zero/shared/util-models';

@Directive()
export class HeaderBase {
  @Input() public model?: InstrumentHeaderModel;
  @Input() public underlying?: InstrumentUnderlyingModel;
  @Input() public isPotentialCustomer = false;

  public quoteFormat = '1.2-2';
  public readonly InstrumentType = InstrumentType;

  protected setQuoteFormat() {
    if (!this.model?.priceScale) {
      return;
    }

    const { priceScale } = this.model;
    this.quoteFormat = `1.${priceScale}-${priceScale}`;
  }
}
